export const settingsColors = [
  '255, 99, 132',
  '54, 162, 235',
  '255, 206, 86',
  '75, 192, 192',
  '153, 102, 255',
  '34, 159, 64',
  '255, 206, 86'
]

export const borderWidth = 1

export const humanTime = [
  {
    title: 'minute',
    time: 60,
    format: 'ds'
  },
  {
    title: 'hour',
    time: 3600,
    format: 'D MMM'
  },
  {
    title: 'day',
    time: 86400,
    format: 'MMM YYYY'
  },
  {
    title: 'week',
    time: 604800,
    format: 'MMM YYYY'
  },
  {
    title: 'month',
    time: 2629743,
    format: 'YYYY'
  },
  {
    title: 'year',
    time: 31556926,
    format: 'unset'
  }
]
